import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

function Content(props) {
    return (
        <div>
            <div className="title">{props.title}</div><br />
            <div id={props.id} dangerouslySetInnerHTML={{__html: props.content}}></div>
        </div>
    );
}

class ShowTagResult extends React.Component {
    constructor(props) {
        super(props);
        let urlName = window.location.href;
        let result = urlName.split("/");
        this.state = {
            dataSet: result[3],
            id: result[4],
            type: result[5],
            api_content: "1",
            api_re: "1",
            api_tagged_content: "loading...",
            api_title: ""
        };
        let URLRoot = "https://oopus.info/retag/query.php";
        // let URLRoot = "http://localhost/retag/query.php";
        let APIURL = `${URLRoot}/${this.state.dataSet}/${this.state.id}/${this.state.type}`;
        // fetch(APIURL)
        // console.log(APIURL);
        fetch(APIURL)
            .then(res => res.json())
            .then((rows) => {
                let tagged_content = rows.content;
                Object.keys(rows.RE).forEach(function (key) {
                    let api_re = new RegExp(`(${rows.RE[key]})`, "i");
                    tagged_content = tagged_content.replace(api_re, "<span class='tagged'>$1</span>");
                    // console.log(tagged_content);
                    // console.log(rows.RE[key]);
                });
                // console.log(tagged_content);
                this.setState({
                    api_content: rows.content,
                    api_re: rows.RE,
                    api_tagged_content: tagged_content,
                    api_title: rows.title,
                });
            });
    }

    tagContent() {
        return this.state.api_re;
    }

    render() {
        return (
            <Content id={this.state.id} content={this.state.api_tagged_content} title={this.state.api_title} />
        );
    }
}

class Main extends React.Component {
    constructor(props) {
        super(props);
        document.title = "Regular Expression Tagging";
    }

    getURLVariables(input) {
        // Function not implemented, consider removing if not needed
    }

    render() {
        return (
            <ShowTagResult />
        );
    }
}

ReactDOM.render(
    <Main />,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js